import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'
import globalCss from '../../../../scss/global.scss'

export class ObjectEditor extends Component {
  constructor ({ variable, variableName, updateParent }) {
    super()
    this.state = {
      obj: variable.args[0] || {},
      showNewEntry: false,
      newKey: ''
    }
  }

  updateObj = (value, key) => {
    const { obj: currentObj } = this.state
    this.setState({
      obj: { ...currentObj, [key]: value }
    })
  }

  handleShowEntryForm = () => {
    this.setState({
      showNewEntry: true
    })
  }

  handleCreateEntry = () => {
    const { obj: muteableObj, newKey } = this.state
    if (newKey.length > 0) {
      this.setState({
        obj: { ...muteableObj, [newKey]: '' },
        showNewEntry: false,
        newKey: ''
      })
    }
  }

  handleUpdateNewKey = evt => {
    this.setState({
      newKey: evt.target.value
    })
  }

  removeEntry (key) {
    const obj = { ...this.state.obj }
    delete obj[key]
    this.setState({
      obj
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    if (nextProps.report === true && report === false) {
      save(variableName, [this.state.obj])
    }
  }

  render () {
    const { app: { primaryColor } } = this.props
    const { obj, showNewEntry, newKey } = this.state
    let entryForm = null
    const fieldRows = Object.keys(obj).map(key => {
      return (
        <div key={key} className={css.row}>
          <p className={css.key}>
            {key}
          </p>
          <label className={css.val}>
            <input
              type='text'
              className={css.option}
              onChange={evt => this.updateObj(evt.target.value, key)}
              value={obj[key]}
            />
          </label>
          <div className={css.btn}>
            <button style={{ color: primaryColor }} type='button' className={css.del} onClick={() => this.removeEntry(key)}>
              <i className={globalCss.iconMinusCircled} />
            </button>
          </div>
        </div>
      )
    })
    if (showNewEntry) {
      entryForm = (
        <div className={css.row}>
          <label className={css.key}>
            <input
              type='text'
              className={css.option}
              onChange={this.handleUpdateNewKey}
              value={newKey}
              placeholder='Entry new key...'
            />
          </label>
          <div className={css.make}>
            <button
              type='button'
              className={css.create}
              onClick={this.handleCreateEntry}
              style={{ backgroundColor: primaryColor }}
            >
              Create Entry
            </button>
          </div>
        </div>
      )
    }
    return (
      <div>
        {fieldRows}
        {entryForm}
        <div className={css.row}>
          <button
            className={css.add}
            onClick={this.handleShowEntryForm}
            type='button'
            style={{ backgroundColor: primaryColor }}
          >
            <i className={globalCss.iconPlus} />
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(ObjectEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/ObjectEditor/index.js